import { VariableValueSimulator } from '../api/variable-value-simulator';

export class AsciiCharacterSimulator implements VariableValueSimulator {
  constructor(
    private options: {
      characters: string;
    } = {
      characters: 'abcdefghijklmnopqrstuvwxyz',
    }
  ) {}

  generateNextValue(): number {
    const index = Math.round(Math.random() * this.options.characters.length);
    return this.options.characters.charCodeAt(index);
  }
}
